export default "__VITE_ASSET__BMFHLPR3__"